var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 4000,
    viewBox: "0 0 1920 4000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_25)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-703.118 -76.5876L696.989 452.336L1280.97 1754.31",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-727.704 -53.1349L672.404 475.771L1255.62 1776.07",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-752.289 -29.6821L647.819 499.224L1230.27 1797.82",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-776.874 -6.24646L623.234 522.677L1204.92 1819.58",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-801.459 17.2059L598.648 546.13L1179.58 1841.33",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-826.045 40.6592L574.063 569.566L1154.23 1863.09",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-850.63 64.1118L549.478 593.018L1128.88 1884.84",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-875.233 87.5468L524.892 616.471L1103.54 1906.6",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-899.818 111L500.307 639.906L1078.19 1928.34",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-924.403 134.452L475.704 663.359L1052.84 1950.11",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-948.989 157.888L451.119 686.812L1027.49 1971.85",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-973.574 181.341L426.534 710.247L1002.15 1993.61",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-998.16 204.793L401.948 733.7L976.802 2015.36",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1022.74 228.228L377.363 757.152L951.45 2037.12",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1047.33 251.681L352.778 780.605L926.098 2058.87",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1071.93 275.134L328.192 804.04L900.763 2080.63",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1096.52 298.587L303.607 827.493L875.411 2102.37",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1121.1 322.022L279.022 850.946L850.06 2124.14",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1145.69 345.475L254.419 874.382L824.725 2145.88",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1170.27 368.928L229.834 897.834L799.373 2167.65",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1194.86 392.381L205.249 921.287L774.021 2189.39",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1219.44 415.816L180.663 944.739L748.669 2211.15",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1244.03 439.268L156.078 968.175L723.335 2232.9",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1268.62 462.721L131.493 991.627L697.983 2254.66",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1293.22 486.157L106.907 1015.08L672.63 2276.41",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1317.8 509.609L82.3221 1038.51L647.279 2298.17",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1342.39 533.062L57.7363 1061.97L621.944 2319.91",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1366.97 556.515L33.1339 1085.42L596.592 2341.66",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1391.56 579.95L8.54855 1108.87L571.24 2363.42",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1416.14 603.403L-16.0365 1132.31L545.906 2385.18",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1440.73 626.855L-40.622 1155.76L520.553 2406.93",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1465.32 650.291L-65.2072 1179.21L495.202 2428.67",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1489.9 673.744L-89.7924 1202.65L469.85 2450.44",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1514.5 697.197L-114.378 1226.1L444.515 2472.18",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1539.09 720.649L-138.98 1249.56L419.163 2493.94",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1563.67 744.084L-163.566 1273.01L393.811 2515.69",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1588.26 767.537L-188.151 1296.44L368.459 2537.45",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1612.84 790.99L-212.737 1319.9L343.125 2559.2",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1637.43 814.425L-237.322 1343.35L317.773 2580.96",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1662.01 837.878L-261.907 1366.78L292.421 2602.71",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1686.6 861.33L-286.492 1390.24L267.086 2624.47",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1711.2 884.766L-311.078 1413.69L241.734 2646.21",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1735.79 908.219L-335.663 1437.12L216.382 2667.98",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1760.37 931.671L-360.266 1460.58L191.048 2689.72",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1784.96 955.124L-384.851 1484.03L165.696 2711.48",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1809.54 978.56L-409.437 1507.48L140.343 2733.23",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1834.13 1002.01L-434.022 1530.92L114.992 2754.99",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1858.71 1025.46L-458.607 1554.37L89.6573 2776.74",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1883.3 1048.9L-483.192 1577.82L64.3054 2798.5",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1907.9 1072.35L-507.778 1601.26L38.9535 2820.24",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1932.49 1095.81L-532.363 1624.71L13.6016 2842.01",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2767.8 1771.65L1246.73 1281.39L571.92 -49.7891",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2789.79 1743.54L1269.68 1253.58L595.268 -76.8486",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2811.78 1715.42L1292.65 1225.77L618.599 -103.908",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2833.79 1687.3L1315.61 1197.96L641.947 -130.968",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855.77 1659.18L1338.56 1170.15L665.278 -158.027",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2877.78 1631.05L1361.52 1142.35L688.609 -185.087",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2899.77 1602.93L1384.47 1114.52L711.956 -212.129",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2921.78 1574.81L1407.44 1086.71L735.288 -239.189",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943.77 1546.69L1430.38 1058.9L758.636 -266.248",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2965.77 1518.56L1453.35 1031.09L781.966 -293.308",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2987.76 1490.46L1476.31 1003.28L805.315 -320.367",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3009.75 1462.34L1499.26 975.475L828.663 -347.427",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3031.76 1434.22L1522.23 947.667L851.994 -374.486",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3053.75 1406.09L1545.17 919.858L875.342 -401.546",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3075.75 1377.97L1568.14 892.049L898.672 -428.605",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3097.74 1349.85L1591.09 864.223L922.021 -455.647",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3119.75 1321.73L1614.05 836.414L945.352 -482.707",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3141.74 1293.6L1637.02 808.605L968.682 -509.766",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3163.74 1265.48L1659.96 780.797L992.031 -536.826",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3185.73 1237.36L1682.93 752.988L1015.36 -563.885",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3207.72 1209.24L1705.88 725.179L1038.71 -590.945",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3229.73 1181.13L1728.84 697.37L1062.04 -618.004",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3251.72 1153.01L1751.79 669.544L1085.39 -645.046",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3273.72 1124.89L1774.75 641.736L1108.72 -672.106",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3295.71 1096.76L1797.72 613.927L1132.07 -699.166",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3317.72 1068.64L1820.66 586.118L1155.4 -726.225",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3339.71 1040.52L1843.63 558.309L1178.75 -753.285",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3361.72 1012.4L1866.58 530.501L1202.08 -780.344",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3383.7 984.274L1889.54 502.692L1225.43 -807.403",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3405.69 956.152L1912.49 474.883L1248.76 -834.463",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3427.7 928.047L1935.45 447.057L1272.1 -861.505",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3449.69 899.925L1958.42 419.248L1295.44 -888.565",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3471.7 871.803L1981.37 391.439L1318.78 -915.624",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3493.68 843.68L2004.33 363.631L1342.11 -942.684",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3515.69 815.558L2027.28 335.822L1365.46 -969.743",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3537.68 787.435L2050.24 308.013L1388.79 -996.803",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3559.69 759.313L2073.19 280.205L1412.14 -1023.86",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3581.68 731.191L2096.16 252.396L1435.47 -1050.92",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3603.68 703.068L2119.12 224.587L1458.82 -1077.98",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3625.67 674.963L2142.07 196.761L1482.15 -1105.02",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3647.66 646.841L2165.03 168.952L1505.5 -1132.08",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3669.67 618.719L2187.98 141.143L1528.83 -1159.14",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3691.66 590.596L2210.95 113.335L1552.18 -1186.2",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3713.66 562.474L2233.91 85.5257L1575.51 -1213.26",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3735.65 534.351L2256.86 57.717L1598.86 -1240.32",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3757.66 506.229L2279.82 29.9084L1622.19 -1267.38",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3779.65 478.107L2302.77 2.09971L1645.54 -1294.44",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3801.66 449.984L2325.74 -25.7266L1668.87 -1321.48",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3823.64 421.879L2348.68 -53.5355L1692.22 -1348.54",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3845.63 393.757L2371.65 -81.344L1715.55 -1375.6",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3867.64 365.634L2394.61 -109.153L1738.89 -1402.66",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3889.63 337.512L2417.56 -136.962L1762.23 -1429.72",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3911.64 309.39L2440.52 -164.771L1785.57 -1456.78",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3933.63 281.267L2463.47 -192.579L1808.9 -1483.84",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3955.63 253.145L2486.44 -220.388L1832.25 -1510.9",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3977.62 225.022L2509.39 -248.214L1855.58 -1537.94",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3999.61 196.9L2532.35 -276.023L1878.93 -1565",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/Pattern.50d74d9baa1bd0d6fc8cec60b0239448.svg";
export { ForwardRef as ReactComponent };